<template>
  <Page>
    <div class="mx-auto" style="max-width: 1032px">
      <div class="flex flex-wrap gap-2 md:gap-6 my-6 md:my-8">
        <div class="rounded" v-for="(x, i) in brands" :key="i">
          <img
            class="w-26 h-26 md:w-60 md:h-60 bg-white-005 rounded-2xl"
            :src="require(`@/assets/images/brand_${i + 1}.png`)"
            alt=""
          />
        </div>
      </div>
      <div class="flex justify-end text-base text-whitebase">
        <button class="px-6 py-4 daobase-btn" @click="doDownload">
          <span></span>
          Download
        </button>
      </div>
    </div>
  </Page>
  <Footer />
</template>

<script setup>
import Page from '@/components/Page.vue';
import LineTitle from '@/components/LineTitle.vue';
import Button from '@/components/Button.vue';
import Footer from '@/components/Framework/Footer.vue';
const brands = Array(8).fill(0);

const doDownload = async () => {
  window.location.href =
    'https://daobase-public.s3.ap-east-1.amazonaws.com/beep/DAOBase_logo.zip';
};
</script>

<style scoped></style>
